import React from "react";

export default function Ticker() {
  const items = [
    "EF-3 TORNADO LOGGED IN GREENSBURG, OK",
    "RADAR SWEEP ACTIVE :: SECTOR 4",
    "TEAM ROSTER OPEN — APPLICATIONS WELCOME",
    "MOBILE MESONET DEPLOYED",
    "DATA POINTS COLLECTED: 12,488",
    "DIXIE ALLEY ADVISORY :: HIGH RISK",
    "LIGHTNING DENSITY 38/MIN",
    "STORM CELL VELOCITY 64 MPH SW",
  ];
  const loop = [...items, ...items];
  return (
    <div className="ticker" data-testid="storm-ticker">
      <div className="ticker-track animate-marquee">
        {loop.map((t, i) => (
          <span key={i} className="inline-flex items-center gap-3">
            <span className="ticker-dot">◆</span>
            <span>{t}</span>
          </span>
        ))}
      </div>
    </div>
  );
}
